module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/cms-panel-active.c8b37189.svg";